import moment from 'moment'
import styles from './message-element.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import MessageCreatorInfo from '@BUP/components/ModeBUP/MessageCreatorInfo'
import classNames from 'classnames'

const MessageElement = ({
  message,
  checkNotification,
  isLoading
}) => {
  const isNotification = Boolean(checkNotification)
  const userInfo = classNames({
    [styles.user_info_details]: isNotification,
    [styles.user_info_details_read]: !isNotification
  })

  const messageContent = classNames({
    [styles.message_content]: isNotification,
    [styles.message_content_read]: !isNotification
  })

  const dotNotification = classNames({
    [styles.notification_dot]: isNotification,
    [styles.notification_dot_read]: !isNotification
  })

  if (!message) return null

  if (isLoading) return <BupSpinner />

  return (
    <div className={styles.message_element_container}>
      <div className={styles.message_element_wrapper}>
        <div className={styles.message_data}>
          <div className={styles.notificacion_wrapper}>
            <div className={dotNotification}>
              <span />
            </div>
          </div>
          <div className={userInfo}>
            <MessageCreatorInfo message={message} />
            <span className={messageContent}>
              {message.content || ''}
            </span>
            {`${moment(message.createdAt).format('LLLL')} (${moment(message.createdAt).fromNow()})`}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MessageElement
